import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledDealflowDashboardCard from 'components/organisms/Cards/DealflowDashboardCard/DealflowDashboardCard.styles';
import DealflowPieChart from 'components/organisms/Charts/DealflowPieChart/DealflowPieChart';
import {useClientStatisticDealflow} from 'services/client/statistic/statistic.utils';
import Box from 'components/atoms/Layout/Box/Box';
import {P} from 'components/atoms/Text/Typography/Typography';
import {useLinkNavigate} from 'helpers/hooks/links';
import utils from 'helpers/utils';
import SimpleLoader from 'components/molecules/Loaders/SimpleLoader/SimpleLoader';

const DealflowDashboardCard = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DealflowDashboardCard');

  const [dealflow, setDealflow] = useState(null);
  const [dealflowBreakdown, isStatisticLoading] = useClientStatisticDealflow();

  const isLoading = isStatisticLoading || !utils.isDefined(dealflow);

  const navigate = useLinkNavigate();

  useEffect(() => {
    if (dealflowBreakdown) {
      setDealflow(dealflowBreakdown
        .filter((df) => df.id > 0)
        .map((df) => ({
          count: df.value,
          label: df.label,
          status: df.id
        })));
    }
  }, [dealflowBreakdown]);

  const handleClick = (e, release, data) => {
    if (data?.id) {
      const prefix = data?.id;
      navigate({
        event: e,
        to: `/dealflow/table?custom=dealflow:${prefix}_-1`,
        keepSearchParams: true
      });
    }
  };

  return <StyledDealflowDashboardCard ref={ref} {...innerProps}
                                      title="Deal flow summary">
    {(utils.isDefined(dealflow) && dealflow?.length > 0) ?
      <DealflowPieChart dealflow={dealflow}
                        showNoDealflow={false}
                        onClick={handleClick}
                        isLoading={isLoading} /> : null}

    {(!utils.isDefined(dealflow) || dealflow?.length === 0) ? (
      (!utils.isDefined(dealflow) || isLoading) ?
        <SimpleLoader className="DashboardCard-loader" /> :
        <Box className="DashboardCard-empty">
          <P>No deal flow data found</P>
        </Box>
    ) : null}
  </StyledDealflowDashboardCard>
});

DealflowDashboardCard.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DealflowDashboardCard;
